import type { AutomationInterval, AvailabilityType } from './query';

export interface SolaceConfig {
  enabled: boolean;
  brokerUrl: string;
  vpnName: string;
  queueName: string;
  username: string;
  password: string;
  interval: AutomationInterval;
}

export interface SapBtpConfig {
  enabled: boolean;
  serviceUrl: string;
  clientId: string;
  clientSecret: string;
  tokenUrl: string;
  apiPath: string;
  interval: AutomationInterval;
}

export interface QueryFormData {
  name: string;
  description: string;
  sqlQuery: string;
  automationEnabled: boolean;
  automationWebhookUrl: string;
  automationInterval: AutomationInterval;
  selectedColumns: string[];
  filterColumns: string[];
  documentationDescription: string;
  availabilityType: AvailabilityType;
  endpointSlug: string;
  isActive: boolean;
  solaceConfig: SolaceConfig;
  sapBtpConfig: SapBtpConfig;
}

export const defaultQueryFormData: QueryFormData = {
  name: '',
  description: '',
  sqlQuery: '',
  automationEnabled: false,
  automationWebhookUrl: '',
  automationInterval: '1h',
  selectedColumns: [],
  filterColumns: [],
  documentationDescription: '',
  availabilityType: 'api',
  endpointSlug: '',
  isActive: true,
  solaceConfig: {
    enabled: false,
    brokerUrl: '',
    vpnName: '',
    queueName: '',
    username: '',
    password: '',
    interval: '1h'
  },
  sapBtpConfig: {
    enabled: false,
    serviceUrl: '',
    clientId: '',
    clientSecret: '',
    tokenUrl: '',
    apiPath: '',
    interval: '1h'
  }
};
